import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { buildParser } from '@lezer/generator';
import { LRLanguage, foldNodeProp, foldInside, indentNodeProp } from "@codemirror/language"
import { styleTags, tags } from "@lezer/highlight"
import { getObjectDiff } from '@donedeal0/superdiff';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient,
  ) { }
  partitions:any
  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' })
  userName;
  userLName = "";
  userFName = "";
  userId
  customer;
  serviceProviderName;
  platformMap = {};
  hostlist: string[] = [];
  forcePwd = false;
  $selectedDashboardLabel: BehaviorSubject<any> = new BehaviorSubject({});
  $userLogged: BehaviorSubject<boolean> = new BehaviorSubject(false);
  userLogged_ = this.$userLogged.asObservable()
  $userLoggedoff: Subject<boolean> = new Subject();
  userLoggedoff_ = this.$userLoggedoff.asObservable();
  commonPlatformFields: any[] = [];
  $customerChanged: Subject<any> = new Subject();
  customerChanged_ = this.$customerChanged.asObservable();
  metaData: any;
  $metaData: Subject<any> = new Subject();
  $metaDataUpdated: BehaviorSubject<any> = new BehaviorSubject({});
  menuSubject = new Subject<any>();
  $menu_array = this.menuSubject.asObservable();
  timeRange: any;
  timeZone: string;
  previewRef;
  dashboard_preview: any = null;
  mat_spinner_login_state: boolean = false;
  already_login_warning_msg = "An active session exists. Would you like to terminate that session?";
  isOrganization: boolean = false;

  public _alertName = new BehaviorSubject<string | null>(null);
  public $alertName = this._alertName.asObservable();

  setAlertTitle(value: any) {
    this._alertName.next(value);
  }

  public _sidebarExpanded = new BehaviorSubject<boolean | null>(false);
  public $sidebarExpanded = this._sidebarExpanded.asObservable();

  sidebarState(value: any) {
    if(this._sidebarExpanded.value == true){
      this._sidebarExpanded.next(false);
    }else{
      this._sidebarExpanded.next(true);
    }
  }

  getCurrentUserId(){
    // return this.analystlist.find(item => item.disp === this.userName)?.value ?? 0
    return this.userId
  }

  get_assign_others_alerts_state(){
    return this.analystlist.find(item => item.disp === this.userName)?.is_assign_others ?? 0
  }

  terminal_status = [2,5]
  reassigned_status = [4]

  // actions={
  //   "actions": {
  //       "0": {
  //           "disp": "Triggered",
  //           "value": 0,
  //           "status": "open",
  //           "priority": false,
  //           "reassign": false,
  //           "isDefault": true,
  //           "hasReason": false,
  //           "next": [
  //               "1"
  //           ],
  //           "reason": {
  //               "0": {
  //                   "value": "-",
  //                   "disp": "-"
  //               }
  //           }
  //       },
  //       "1": {
  //           "disp": "Acknowledged",
  //           "value": 1,
  //           "status": "open",
  //           "priority": false,
  //           "reassign": false,
  //           "isDefault": true,
  //           "hasReason": false,
  //           "next": [
  //               "3",
  //               "2",
  //               "4",
  //               "5"
  //           ],
  //           "reason": {
  //               "0": {
  //                   "value": "-",
  //                   "disp": "-"
  //               }
  //           }
  //       },
  //       "3": {
  //           "disp": "Waiting",
  //           "value": 3,
  //           "status": "open",
  //           "priority": false,
  //           "reassign": false,
  //           "isDefault": false,
  //           "hasReason": true,
  //           "next": [
  //               "2",
  //               "5"
  //           ],
  //           "reason": {
  //               "0": {
  //                   "disp": "Monitoring",
  //                   "value": 0
  //               },
  //               "1": {
  //                   "disp": "Investigating",
  //                   "value": 1
  //               },
  //               "2": {
  //                   "disp": "Requires additional evidence",
  //                   "value": 2
  //               },
  //               "3": {
  //                   "disp": "Awaiting customer response",
  //                   "value": 3
  //               }
  //           }
  //       },
  //       "2": {
  //           "disp": "Closed",
  //           "value": 2,
  //           "status": "close",
  //           "priority": false,
  //           "reassign": false,
  //           "isDefault": false,
  //           "hasReason": true,
  //           "next": [],
  //           "reason": {
  //               "0": {
  //                   "disp": "Benign",
  //                   "value": 0
  //               },
  //               "1": {
  //                   "disp": "False Positive",
  //                   "value": 1
  //               },
  //               "2": {
  //                   "disp": "Known Activity",
  //                   "value": 2
  //               },
  //               "3": {
  //                   "disp": "Duplicate",
  //                   "value": 3
  //               },
  //               "4": {
  //                   "disp": "Policy Exception",
  //                   "value": 4
  //               },
  //               "5": {
  //                   "disp": "Test Alert",
  //                   "value": 5
  //               }
  //           }
  //       },
  //       "4": {
  //           "disp": "Re-assigned",
  //           "value": 4,
  //           "status": "close",
  //           "priority": true,
  //           "reassign": true,
  //           "isDefault": false,
  //           "hasReason": true,
  //           "next": [],
  //           "reason": {
  //               "0": {
  //                   "disp": "Domain ownership",
  //                   "value": 0
  //               },
  //               "1": {
  //                   "disp": "Incorrect assignment",
  //                   "value": 1
  //               },
  //               "2": {
  //                   "disp": "Review",
  //                   "value": 2
  //               },
  //               "3": {
  //                   "disp": "Escalation",
  //                   "value": 3
  //               },
  //               "4": {
  //                   "disp": "Other",
  //                   "value": 4
  //               }
  //           }
  //       },
  //       "5": {
  //           "disp": "Promoted",
  //           "value": 5,
  //           "status": "close",
  //           "priority": true,
  //           "reassign": false,
  //           "isDefault": false,
  //           "hasReason": false,
  //           "next": [],
  //           "reason": {
  //               "0": {
  //                   "value": "-",
  //                   "disp": "-"
  //               }
  //           }
  //       }
  //   }
  // }

  actions={
    "actions": {
      "0": {
        "disp": "Un-Assigned",
        "value": 0,
        "actionDisp": "",
        "icon": "",
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": true,
        "hasReason": false,
        "comment":false,
        "next": [
          "1",
          "2",
          "3"
        ],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      },
      "1": {
        "disp": "Auto-Assigned",
        "actionDisp": "",
        "icon": "",
        "value": 1,
        "status": "open",
        "priority": false,
        "reassign": true,
        "isDefault": true,
        "hasReason": false,
        "comment":false,
        "next": [
          "3",
          "4",
          "5",
          "6"
        ],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      },
      "2": {
        "disp": "Self Assigned",
        "actionDisp": "Self-assign",
        "icon": "person_add",
        "value": 2,
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": false,
        "hasReason": false,
        "comment":false,
        "next": [
          "3",
          "4",
          "5",
          "6"
        ],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      },
      "3": {
        "disp": "Re-Assigned",
        "actionDisp": "Re-assign",
        "icon": "swap_horiz",
        "value": 3,
        "status": "open",
        "priority": false,
        "reassign": true,
        "isDefault": false,
        "hasReason": true,
        "comment":false,
        "next": [
          "3",
          "4",
          "5",
          "6"
        ],
        "reason": {
          "0": {
            "disp": "Escalating to Tier 2 specialist",
            "value": 0
          },
          "1": {
            "disp": "Reassigning for platform expertise",
            "value": 1
          },
          "2": {
            "disp": "Shift handover",
            "value": 2
          },
          "3": {
            "disp": "Workload rebalancing",
            "value": 3
          },
          "4": {
            "disp": "Further investigation required",
            "value": 4
          },
          "5": {
            "disp": "Other",
            "value": 5
          }
        }
      },
      "4": {
        "disp": "Waiting",
        "actionDisp": "Wait",
        "icon": "hourglass_top",
        "value": 4,
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": false,
        "hasReason": true,
        "comment":true,
        "next": [
          "3",
          "5",
          "6"
        ],
        "reason": {
          "0": {
            "disp": "Awaiting response from end user",
            "value": 0
          },
          "1": {
            "disp": "Pending host isolation verification",
            "value": 1
          },
          "2": {
            "disp": "Monitoring for further telemetry events",
            "value": 2
          },
          "3": {
            "disp": "Awaiting threat intel sandbox analysis",
            "value": 3
          },
          "4": {
            "disp": "Pending approval for remediation action",
            "value": 4
          },
          "5": {
            "disp": "Follow up required in next shift",
            "value": 5
          },
          "6": {
            "disp": "Other",
            "value": 6
          }
        }
      },
      "5": {
        "disp": "Closed",
        "actionDisp": "Close",
        "icon": "check_circle",
        "value": 5,
        "status": "close",
        "priority": false,
        "reassign": false,
        "isDefault": false,
        "hasReason": true,
        "comment":true,
        "next": [],
        "reason": {
          "0": {
            "disp": "Benign activity / False Positive verified",
            "value": "0"
          },
          "1": {
            "disp": "Resolved - Remediation actions completed",
            "value": "1"
          },
          "2": {
            "disp": "Known authorized testing / administrative maintenance",
            "value": "2"
          },
          "3": {
            "disp": "Duplicate alert / Already investigated in incident",
            "value": "3"
          },
          "4": {
            "disp": "System policy tuned / Rule exception added",
            "value": "4"
          },
          "5": {
            "disp": "No malicious indicator found",
            "value": "5"
          },
          "6": {
            "disp": "Closed by SOC Analyst",
            "value": "6"
          },
          "7": {
            "disp": "Other",
            "value": "7"
          }
        }
      },
      "6": {
        "disp": "Promoted",
        "actionDisp": "Promote",
        "icon": "rocket_launch",
        "value": 6,
        "status": "close",
        "priority": true,
        "reassign": false,
        "isDefault": false,
        "hasReason": true,
        "comment":true,
        "next": [],
        "reason": {
          "0": {
            "disp": "Confirmed compromise - Escalating to Incident Response",
            "value": "0"
          },
          "1": {
            "disp": "High risk credential theft detected - SOAR playbook initiated",
            "value": "1"
          },
          "2": {
            "disp": "Ransomware / Lateral movement indicators detected",
            "value": "2"
          },
          "3": {
            "disp": "Critical asset impacted - Immediate containment required",
            "value": "3"
          },
          "4": {
            "disp": "Promoting to SOAR for automated response",
            "value": "4"
          },
          "5": {
            "disp": "Other",
            "value": "5"
          }
        }
      }
    }
  }

  priority_option = [
    {
      "disp": "Select Priority (Optional)",
      "value": ""
    },
    {
      "disp":"P1",
      "value":1
    },
    {
      "disp":"P2",
      "value":2
    },
    {
      "disp":"P3",
      "value":3
    }
  ]

  analystlist:any = []

  // severity_map = [
  //   {"disp":"Critical","value":"critical"},
  //   {"disp":"High","value":"high"},
  //   {"disp":"Medium","value":"medium"},
  //   {"disp":"Low","value":"low"},
  //   {"disp":"Info","value":"informational"}
  // ]

  state_map = [
    {"disp":"All States","value":"all"},
    {"disp":"Un-assigned","value":0},
    {"disp":"Auto-assigned","value":1},
    {"disp":"Self Assigned","value":2},
    {"disp":"Re-assigned","value":3},
    {"disp":"Waiting","value":4},
  ]

  severity_map = [
    {"disp":"All Severites","value":"all"},
    {"disp":"Critical","value":"critical"},
    {"disp":"High","value":"high"},
    {"disp":"Medium","value":"medium"},
    {"disp":"Low","value":"low"},
    {"disp":"Informational","value":"informational"}
  ]

  platform_map = []


  getLeastActionStatus(dedup_details:any){
    let leastStatus = Math.min(...dedup_details.map(item => item.status));
    return leastStatus
  }

  getActions(){
    let arr=[]
    Object.keys(this.actions.actions).forEach((list:any)=>{
      if(!this.actions.actions[list].isDefault){
        let obj ={}
        obj["disp"]=this.actions.actions[list].actionDisp
        obj["value"]=this.actions.actions[list].value
        arr.push(obj)
      }
    })
    return arr
  }

  getAllFunction(){
    let arr=[]
    Object.keys(this.actions.actions).forEach((list:any)=>{
      if(this.actions.actions[list].value){
        let obj ={}
        obj["disp"]=this.actions.actions[list].disp
        obj["value"]=this.actions.actions[list].value
        arr.push(obj)
      }
      
    })
    return arr
  }
  
  getCurrentStatusDisp(current_status:number){
    return {"disp":this.actions.actions[current_status.toString()]["disp"],"value":current_status}
  }

  getActionCurrentStaus(currentStatus:number){
    let arr=[]
    this.actions.actions[currentStatus.toString()].next.forEach(element => {
      let obj ={}
      obj["disp"]=this.actions.actions[element].disp
      obj["value"]=this.actions.actions[element].value
      arr.push(obj)
    });
    return arr
  }

  getreason(action){
    let arr=[]
    Object.keys(this.actions.actions[action].reason).forEach((list:any)=>{
      let obj ={}
      obj["disp"]=this.actions.actions[action].reason[list].disp
      obj["value"]=this.actions.actions[action].reason[list].value
      arr.push(obj)
    })
    return arr
  }


  titles={
    "overview":"Overview",
    "collapse_nav":"Collapse Navigation"
  }

  // menu=[
  //   {
  //     "disp":"SECOPS",
  //     "value": "secops",
  //     // "icon":"assets/alerts/update-action.svg",
  //     "icon":'security',
  //     "expand":false,
  //     "enable":true,
  //     "list":[
  //       {
  //         "disp":"Alerts",
  //         "value":"alerts",
  //         "desc":"Real-time threat detection queues.",
  //         "url":"alerts",
  //         // "icon":"assets/menuicons/alerts.svg",
  //         "icon":'notifications_active',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"#fff5f5",
  //         "color":"#e02200"
  //       },
  //       {
  //         "disp":"Search",
  //         "value":"search",
  //         "desc":"Global telemetry search and discovery.",
  //         "url":"log-search",
  //         // "icon":"assets/menuicons/explore.svg",
  //         "icon":'search',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"#eef7fc",
  //         "color":"#0079b8"
  //       },
  //       {
  //         "disp":"Detections",
  //         "value":"rule",
  //         "desc":"Configure logic and detection rules.",
  //         "url":"rule",
  //         // "icon":"assets/menuicons/rule.svg",
  //         "icon":'policy',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"#f0fff0",
  //         "color":"#2f8400"
  //       },
  //       {
  //         "disp":"IP Intelligence",
  //         "value":"intel-list",
  //         "desc":"Global IP reputation and threat intelligence lookup.",
  //         "url":"intel-list",
  //         // "icon":"assets/menuicons/intel-list.svg",
  //         "icon":'public',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"gray-50",
  //         "color":"gray-600"
  //       },
  //       {
  //         "disp":"Dashboard",
  //         "value":"studio",
  //         "desc":"Visual dashboard & reports.",
  //         "url":"dashboard",
  //         // "icon":"assets/menuicons/studio.svg",
  //         "icon":'space_dashboard',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"gray-50",
  //         "color":"gray-600"
  //       },{
  //         "disp":"Studio",
  //         "value":"studio",
  //         "desc":"Visual dashboard & report builder.",
  //         "url":"designer",
  //         // "icon":"assets/menuicons/studio.svg",
  //         "icon":'code',
  //         "isSelectable":true,
  //         "isSelected":false,
  //         "bg":"gray-50",
  //         "color":"gray-600"
  //       },
  //       // {
  //       //   "disp":"Dashboards",
  //       //   "value":"dashboards",
  //       //   "desc":"Real-time insights into security events and system health.",
  //       //   "url":"dashboard",
  //       //   "icon":"assets/menuicons/bar-chart.svg",
  //       //   "isSelectable":true,
  //       //   "isSelected":false
  //       // },
  //       // {
  //       //   "disp":"Intel List",
  //       //   "value":"intel-list",
  //       //   "desc":"Maintain custom and imported intelligence data sets.",
  //       //   "url":"intel-list",
  //       //   "icon":"assets/menuicons/intel-list.svg",
  //       //   "isSelectable":true,
  //       //   "isSelected":false
  //       // },
  //       // {
  //       //   "disp":"User",
  //       //   "value":"user",
  //       //   "desc":"Manage user accounts and access privileges.",
  //       //   "url":"user",
  //       //   "icon":"assets/menuicons/user.svg",
  //       //   "isSelectable":true,
  //       //   "isSelected":false
  //       // },
  //       // {
  //       //   "disp":"Role",
  //       //   "value":"role",
  //       //   "desc":"Define and assign roles to control system access.",
  //       //   "url":"role",
  //       //   "icon":"assets/menuicons/role.svg",
  //       //   "isSelectable":true,
  //       //   "isSelected":false
  //       // }
  //     ]
  //   },
  //   {
  //     "disp":"PLATFORM",
  //     "value": "platform",
  //     // "icon":"assets/alerts/multi-match-events.svg",
  //     "icon":'layers',
  //     "expand":false,
  //     "enable":true,
  //     "list":[
  //       {
  //         "disp":"Pipeline",
  //         "value":"pipeline",
  //         "desc":"Monitor real-time data throughput and ingestion health.",
  //         "url":"pipeline",
  //         // "icon":"assets/menuicons/organization.svg",
  //         "icon":'alt_route',
  //         "isSelectable":false,
  //         "isSelected":false,
  //         "bg":"#eef7fc",
  //         "color":"#0079b8"
  //       },
  //       {
  //         "disp":"Vitals",
  //         "value":"vitals",
  //         "desc":"View system uptime, resource usage, and node status.",
  //         "url":"vitals",
  //         // "icon":"assets/menuicons/monitor.svg",
  //         "icon":'monitor_heart',
  //         "isSelectable":false,
  //         "isSelected":false,
  //         "bg":"#f0fff0",
  //         "color":"#2f8400"
  //       },
  //       {
  //         "disp":"Sources",
  //         "value":"sources",
  //         "desc":"View details of current data source integrations.",
  //         "url":"sources",
  //         // "icon":"assets/menuicons/changeCustomer.svg",
  //         "icon":'input',
  //         "isSelectable":false,
  //         "isSelected":false,
  //         "bg":"#fffcf0",
  //         "color":"#eb8d00"
  //       },
  //       {
  //         "disp":"Notifications",
  //         "value":"notifications",
  //         "desc":"View system-generated notifications and alerts.",
  //         "url":"notifications",
  //         // "icon":"assets/notification.svg",
  //         "icon":'notifications',
  //         "isSelectable":false,
  //         "isSelected":false,
  //         "bg":"#f0fff0",
  //         "color":"#2f8400"
  //       }
  //     ]
  //   },
    
  // ]

  menu = []
    

  partitionsMapObj ={}


  
  grammarTemplate = `@top Scripts { 
    statement{
    SearchCommand FetchCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand FetchCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand ByCommand FetchCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand WhereCommand FetchCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand ByCommand WhereCommand FetchCommand LimitCommand? SaveCommand? |
    SearchCommand FetchCommand SortCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand ByCommand WhereCommand FetchCommand SortCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand WhereCommand FetchCommand SortCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand ByCommand FetchCommand SortCommand LimitCommand? SaveCommand? |
    SearchCommand CalculateCommand FetchCommand SortCommand LimitCommand? SaveCommand?
}
}

@skip { space }

SearchCommand { search?  ( expression | clause | term ) }
expression { (( term | clause ) logicalOperator ( term | clause )) ( logicalOperator ( term | clause ) ) * }
clause { ( logicalNegate? ParenL expression ParenR ) | ( logicalNegate? ParenL clause ParenR ) }
term { basic | ( logicalNegate? ParenL basic ParenR ) }


basic { stringBasic | stringWildBasic | stringFunctionWhereClause  | numericBasic | numericWildBasic | ipBasic | listBasic | hashTagBasic }
stringWildBasic { stringFields  ( inOperator | containsOperator | startswithOperator | endswithOperator )  (WildcardStringValue | Variable) }
stringBasic { stringFields GenericOperator (StringValue | Variable) }
stringFunctionWhereClause { 
((StringFunctionType1 | StringFunctionType4 | StringFunctionType5 | StringFunctionType6 |  CommonFunctionType2) ((GenericOperator (StringValue | Variable)) | ((inOperator | containsOperator | startswithOperator | endswithOperator) (WildcardStringValue | Variable)))) |
((StringFunctionType2 | NumberFunctionType1 | NumberFunctionType2 | NumberFunctionType3 | CommonFunctionType1) (((GenericOperator | NumericOperator) (NumericValue | Variable)) | (inOperator  (WildcardNumericValue | Variable)))) |
(StringFunctionType3) |
(ListFunctionType1 | ListFunctionType2 | ListFunctionType3)
}
Variable { identifier }
hashTagBasic { hashTags }
nonAggrFunctions { StringFunctionType1 | StringFunctionType2 | StringFunctionType3 | StringFunctionType4 | StringFunctionType5 | StringFunctionType6 | NumberFunctionType1 | NumberFunctionType2 | NumberFunctionType3 | TimestampFunctionType1 | TimestampFunctionType2 | CommonFunctionType1 | CommonFunctionType2 | ListFunctionType1 | ListFunctionType2 | ListFunctionType3 }

StringFunctionType1 { stringFunctionType1Name ParenL stringFields ParenR }
StringFunctionType2 { stringFunctionType2Name ParenL stringFields ParenR }
StringFunctionType3 { stringFunctionType3Name ParenL stringFields Comma StringValue ParenR }
StringFunctionType4 { stringFunctionType4Name ParenL stringFields (Comma StringValue)? ParenR }
StringFunctionType5 { stringFunctionType5Name ParenL stringFields Comma StringValue Comma StringValue ParenR }
StringFunctionType6 { stringFunctionType6Name ParenL stringFields Comma NumericValue Comma NumericValue ParenR }
NumberFunctionType1 { numberFunctionType1Name ParenL (numericFields | NumericValue) ParenR }
NumberFunctionType2 { numberFunctionType2Name ParenL (numericFields | NumericValue) (Comma NumericValue)?  ParenR }
NumberFunctionType3 { numberFunctionType3Name ParenL (numericFields | NumericValue) Comma (numericFields | NumericValue) ParenR }
TimestampFunctionType1 { timestampFunctionType1Name ParenL timestampFields Comma TimeFormat ParenR }
TimestampFunctionType2 { timestampFunctionType2Name ParenL timestampFields Comma NumericValue ParenR }
CommonFunctionType1 { commonFunctionType1Name ParenL numericFields Comma NumericValue ParenR }
CommonFunctionType2 { commonFunctionType1Name ParenL stringFields Comma StringValue ParenR }
ListFunctionType1 { listFunctionType1Name ParenL stringFields Comma WildCardStringListValueSquareBrac ParenR }
ListFunctionType2 { listFunctionType1Name ParenL numericFields Comma WildCardStringListValueSquareBrac ParenR }
ListFunctionType3 { listFunctionType1Name ParenL ipFields  Comma WildCardIPListValueSquareBrac ParenR }

numericWildBasic { (numericFields | ArithmaticExpression) ( inOperator | containsOperator | startswithOperator | endswithOperator ) ( WildcardNumericValue | Variable ) }
numericBasic { (numericFields | ArithmaticExpression) ( GenericOperator | NumericOperator) (NumericValue | Variable) }

ipBasic { (ipFields ( GenericOperator | NumericOperator ) (IpAddress | Variable)) | (ipFields inOperator (wildCardInIpValue | Variable) ) | (ipFields ((containsOperator (wildCardContainsIpValue | Variable)) | (startswithOperator (wildCardStartswithIpValue | Variable)) | (endswithOperator (wildCardEndswithIpValue | Variable)) ) ) }
listBasic { (stringFields ((GenericOperator (stringListValue)) | (inOperator (WildCardStringListValue))) | ipFields ((GenericOperator (iPListValue)) | (inOperator (WildCardIPListValue))) | (numericFields | ArithmaticExpression) ((GenericOperator (numericListValue)) | (inOperator (WildCardNumericListValue)))) }

WildcardStringValue { ParenL (StringValue | StringValue ( ( Comma ) StringValue)*) ParenR }
WildcardNumericValue { ParenL (NumericValue | NumericValue ( ( Comma ) NumericValue)*) ParenR }
WildCardStringListValue { ParenL (stringListValue | stringListValue ( ( Comma ) stringListValue)*) ParenR }
WildCardStringListValueSquareBrac { SquareBracL (stringListValue | stringListValue ( ( Comma ) stringListValue)*) SquareBracR }
WildCardNumericListValue { ParenL (numericListValue | numericListValue ( ( Comma ) numericListValue)*) ParenR }

WildCardIPListValue { ParenL (iPListValue | iPListValue ( ( Comma ) iPListValue)*) ParenR }
WildCardIPListValueSquareBrac { SquareBracL (iPListValue | iPListValue ( ( Comma ) iPListValue)*) SquareBracR }
wildCardInIpValue[@name="WildCardIpValue"] { ParenL ( IpAddress ( Comma IpAddress)*) ParenR }
wildCardStartswithIpValue[@name="WildCardIpValue"] { ParenL ( startsWithIPRule ( Comma startsWithIPRule)*) ParenR }
wildCardEndswithIpValue[@name="WildCardIpValue"] { ParenL ( endsWithIPRule ( Comma endsWithIPRule)*) ParenR }
wildCardContainsIpValue[@name="WildCardIpValue"] { ParenL ( containsIPRule ( Comma containsIPRule)*) ParenR }

startsWithIPRule { StartsWithIP | IpAddress }
endsWithIPRule { EndsWithIP | IpAddress }

containsIPRule { ContainsIP | StartsWithIP | EndsWithIP | IpAddress }

AggFunctionType1 { aggFunctionType1Name ParenL  ( distinct? ( stringFields | numericFields | ipFields ) )? ParenR }
AggFunctionType2 { aggFunctionType2Name ParenL  ( numericFields  | ArithmaticExpression ) ParenR }

CalculateCommand { Pipe  calculate ( ( statsFunc statsAlias? ) | (  statsFunc statsAlias? ) ( Comma ( statsFunc statsAlias? ) )* ) }
statsFunc { AggFunctionType1 |  AggFunctionType2 }

statsAlias { as Alias }
ByCommand { Pipe by (( stringFields | numericFields | (ArithmaticExpression statsAlias?) | ipFields | (nonAggrFunctions statsAlias?))  | (( stringFields | numericFields | (ArithmaticExpression statsAlias?) | ipFields | (nonAggrFunctions statsAlias?)) ( Comma ( stringFields | numericFields | (ArithmaticExpression statsAlias?) | ipFields | (nonAggrFunctions statsAlias?) ) )*)) }

FetchCommand { Pipe fetch ( fetchList | fetchall ) }
fetchList { fetchItem | fetchItem (Comma fetchItem)* }
fetchItem { (stringFields | numericFields | timestampFields | ArithmaticExpression | ipFields | nonAggrFunctions) statsAlias? | Alias }
WhereCommand { Pipe where (whereexpression | whereclause | whereterm) }
SaveCommand { Pipe save as StringValue }


whereexpression { (( whereterm | whereclause ) logicalOperator ( whereterm | whereclause )) ( logicalOperator ( whereterm | whereclause ) ) * }
whereclause { ( ParenL whereexpression ParenR ) | ( ParenL whereclause ParenR ) }
whereterm { wherebasic | ( ParenL wherebasic ParenR ) }
wherebasic { Alias ( GenericOperator | NumericOperator ) NumericValue }

SortCommand { Pipe sort ( (( stringFields | numericFields | timestampFields | ipFields | Alias ) sortOperator ) | (( stringFields | numericFields | timestampFields | ipFields | Alias ) sortOperator) ( Comma (stringFields | numericFields | timestampFields | ipFields | Alias) sortOperator ) * ) }
LimitCommand { Pipe limit NumericValue }

ArithmaticExpression { binaryExpression }
binaryExpression { arithmaticTerm (arithmaticOperator arithmaticTerm)+ }
arithmaticTerm { ParenL binaryExpression ParenR | arithmaticOperand }
arithmaticOperand { NumericValue | numericFields }
arithmaticOperator { Plus | Minus | Mul | Div }

stringFields { (keywordString<"~~platform_string_fields"> | keywordStringQuoted<"~~quoted_platform_string_fields">) }
numericFields { (keywordNumeric<"~~platform_numeric_fields"> | keywordNumericQuoted<"~~quoted_platform_numeric_fields">) }
stringListValue { (keywordStringListValue<"~~string_list_value">) }
numericListValue { (keywordNumericListValue<"~~numeric_list_value">) }
iPListValue { (keywordIPListValue<"~~ip_list_value">) }
hashTags { (keywordHashTags<"#inboundtraffic" | "#outboundtraffic">) }
ipFields { ( keywordIpFields<"~~ip_string_fields"> | keywordIpFieldsQuoted<"~~quoted_platform_ip_fields">) }
timestampFields { ( keywordTimestampFields<"~~timestamp_string_fields">|keywordTimestampFieldsQuoted<"~~quoted_timestamp_string_fields">) }

logicalOperator { (keywordLogical<"AND" | "OR" | "and" | "or">) }
logicalNegate { (keywordNegate<"NOT" | "not">) }
NumericOperator { ("<" | ">" | "<=" | ">=") }
GenericOperator { ("=" | "!=") }
inOperator { (keywordInOperator<"IN">) }
containsOperator { ( keywordContainsOperator<"CONTAINS" | "contains">) }
startswithOperator { ( keywordStartswithOperator<"STARTSWITH" | "startswith">) }
endswithOperator { ( keywordEndswithOperator<"ENDSWITH" | "endswith">) }
aggFunctionType1Name { ( keywordAggFunctionType1Name<"count">) }
aggFunctionType2Name { ( keywordAggFunctionType2Name<"average" | "sum" | "max" | "min">) }
by { ( keywordBy<"BY">) }
as { ( keywordAs<"as" | "AS" >) }
save { ( keywordSave<"SAVE">) }
distinct { ( keywordDistinct<"distinct" | "DISTINCT"> ) }
search { (keywordSearch<"FILTER">) }
calculate { ( keywordCalculate<"CALCULATE">) }
where { ( keywordWhere<"WHERE">) }
fetch { ( keywordFetch<"FETCH">) }
fetchall { ( keywordFetchall<"_all" | "_ALL" >) }
sort { ( keywordSort<"SORT">) }
limit { ( keywordLimit<"LIMIT">) }
sortOperator { (keywordSortOperator<"ASC" | "DSC">) }
stringFunctionType1Name { (keywordStringFunctionType1Name<"lower" | "upper" | "url_decode" | "url_encode">) }
stringFunctionType2Name { (keywordStringFunctionType2Name<"len">) }
stringFunctionType3Name { (keywordStringFunctionType3Name<"match">) }
stringFunctionType4Name { (keywordStringFunctionType4Name<"trim" | "ltrim" | "rtrim" | "concat">) }
stringFunctionType5Name { (keywordStringFunctionType5Name<"replace">) }
stringFunctionType6Name { (keywordStringFunctionType6Name<"substr">) }
numberFunctionType1Name { (keywordNumberFunctionType1Name<"abs" | "ceil" | "floor" | "trunc">) }
numberFunctionType2Name { (keywordNumberFunctionType2Name<"round">) }
numberFunctionType3Name { (keywordNumberFunctionType3Name<"add" | "subtract" | "multiply" | "divide">) }
timestampFunctionType1Name { (keywordTimestampFunctionType1Name<"strftime">) }
timestampFunctionType2Name { (keywordTimestampFunctionType2Name<"bin">) }
commonFunctionType1Name { (keywordCommonFunctionType1Name<"ifempty">) }
listFunctionType1Name { (keywordListFunctionType1Name<"exists_in_the_list">) }

keywordSave<term> { @specialize[@name = "Save"]<identifier, term> }
keywordString<term> { @specialize[@name = "StringFields"]<identifier, term> }
keywordStringQuoted<term> { @specialize[@name = "StringFields"]<quotedAlias, term> }
keywordNumeric<term> { @specialize[@name = "NumericFields"]<identifier, term> }
keywordNumericQuoted<term> { @specialize[@name = "NumericFields"]<quotedAlias, term> }
keywordLogical<term> { @specialize[@name = "LogicalOperator"]<identifier, term> }
keywordNegate<term> { @specialize[@name = "LogicalNegate"]<identifier, term> }
keywordInOperator<term> { @specialize[@name = "InOperator"]<identifier, term> }
keywordContainsOperator<term> { @specialize[@name = "ContainsOperator"]<identifier, term> }
keywordStartswithOperator<term> { @specialize[@name = "StartswithOperator"]<identifier, term> }
keywordEndswithOperator<term> { @specialize[@name = "EndswithOperator"]<identifier, term> }
keywordAggFunctionType1Name<term> { @specialize[@name = "AggFunctionType1Name"]<identifier, term> }
keywordAggFunctionType2Name<term> { @specialize[@name = "AggFunctionType2Name"]<identifier, term> }
keywordBy<term> { @specialize[@name = "By"]<identifier, term> }
keywordAs<term> { @specialize[@name = "As"]<identifier, term> }
keywordDistinct<term> { @specialize[@name = "Distinct"]<identifier, term> }
keywordSearch<term> { @specialize[@name = "Search"]<identifier, term> }
keywordCalculate<term> { @specialize[@name = "Calculate"]<identifier, term> }
keywordWhere<term> { @specialize[@name = "Where"]<identifier, term> }
keywordFetch<term> { @specialize[@name = "Fetch"]<identifier, term> }
keywordFetchall<term> { @specialize[@name = "Fetchall"]<identifier, term> }
keywordSort<term> { @specialize[@name = "Sort"]<identifier, term> }
keywordLimit<term> { @specialize[@name = "Limit"]<identifier, term> }
keywordIpFields<term> { @specialize[@name = "IpFields"]<identifier, term> }
keywordIpFieldsQuoted<term> { @specialize[@name = "IpFields"]<quotedAlias, term> }
keywordTimestampFields<term> { @specialize[@name = "TimestampFields"]<identifier, term> }
keywordTimestampFieldsQuoted<term> { @specialize[@name = "TimestampFields"]<quotedAlias, term> }
keywordSortOperator<term> { @specialize[@name = "SortOperator"]<identifier, term> }
keywordStringListValue<term> { @specialize[@name = "StringListValue"]<identifier, term> }
keywordNumericListValue<term> { @specialize[@name = "NumericListValue"]<identifier, term> }
keywordIPListValue<term> { @specialize[@name = "IPListValue"]<identifier, term> }
keywordHashTags<term> { @specialize[@name = "HashTags"]<identifier, term> }
keywordStringFunctionType1Name<term> { @specialize[@name = "StringFunctionType1Name"]<identifier, term> }
keywordStringFunctionType2Name<term> { @specialize[@name = "StringFunctionType2Name"]<identifier, term> }
keywordStringFunctionType3Name<term> { @specialize[@name = "StringFunctionType3Name"]<identifier, term> }
keywordStringFunctionType4Name<term> { @specialize[@name = "StringFunctionType4Name"]<identifier, term> }
keywordStringFunctionType5Name<term> { @specialize[@name = "StringFunctionType5Name"]<identifier, term> }
keywordStringFunctionType6Name<term> { @specialize[@name = "StringFunctionType6Name"]<identifier, term> }
keywordNumberFunctionType1Name<term> { @specialize[@name = "NumberFunctionType1Name"]<identifier, term> }
keywordNumberFunctionType2Name<term> { @specialize[@name = "NumberFunctionType2Name"]<identifier, term> }
keywordNumberFunctionType3Name<term> { @specialize[@name = "NumberFunctionType3Name"]<identifier, term> }
keywordTimestampFunctionType1Name<term> { @specialize[@name = "TimestampFunctionType1Name"]<identifier, term> }
keywordTimestampFunctionType2Name<term> { @specialize[@name = "TimestampFunctionType2Name"]<identifier, term> }
keywordCommonFunctionType1Name<term> { @specialize[@name = "CommonFunctionType1Name"]<identifier, term> }
keywordListFunctionType1Name<term> { @specialize[@name = "ListFunctionType1Name"]<identifier, term> }

Alias { (quotedAlias   | identifier) }

@tokens {
space { @whitespace+ }
ParenL[@name="openparam"] { '(' }
ParenR[@name="closeparam"] { ')' } 
SquareBracL { '[' }
SquareBracR { ']' }
Pipe { '|' }  
Comma { ',' }
Plus { "+" }
Minus { "-" }
Mul { "*" }
Div { "/" }
NumericValue { "-"? $[0-9]+ ("." $[0-9]+)? }
escapedDoubleQuote { """" }
content { (escapedDoubleQuote | !["])* } 
StringValue { '"' content '"' }
formats { ("%d %m %y %H:%M:%S" | "%d %m %y %H:%M" | "%d %m %y %H" | "%d %m %y" ) }
TimeFormat { '"' formats '"' }
ipdigit { ($[1-9]) | ($[1-9]$[0-9]) |  ( ($[1]$[0-9]$[0-9]) | ($[2]$[0-4]$[0-9]) | ($[2]$[5]$[0-5]) )}
ip { ipdigit "." (ipdigit | $[0]) "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
IpAddress { "'" ip ("/" ($[0-9] | $[1-2]$[0-9] | $[3]$[0-2]))? "'"}
partialip6 { "." (ipdigit | $[0]) }
partialip8 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
partialip10 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
partialip11 { "." (ipdigit | $[0]) "." }
partialip12 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) "."}
StartsWithIP { "'" ipdigit (partialip6 | partialip8 | partialip11 | partialip12 | ".")? "'"}
EndsWithIP { "'" (partialip6 | partialip8 | partialip10)  ("/" ($[0-9] | $[1-2]$[0-9] | $[3]$[0-2]))?"'" }
ContainsIP { "'" (partialip11 | partialip12) "'" }  
identifier { $[A-Za-z_$] ($[A-Za-z0-9_$.])+ }  
quotedAlias { '"' (!["])* '"' }
}

@detectDelim`

  // assent = {
  //   "alert": {
  //     create: { allowed: false, action: 'hide' },
  //     edit: { allowed: false, action: 'hide' },
  //     delete: { allowed: true, action: 'disable' },
  //     view: { allowed: true, action: 'disable' }
  //   },
  //   "user": {
  //     create: { allowed: true, action: 'disable' },
  //     edit: { allowed: false, action: 'hide' },
  //     delete: { allowed: false, action: 'hide' },
  //     view: { allowed: true, action: 'disable' }
  //   },
  //   "report": {
  //     create: { allowed: true, action: 'disable' },
  //     edit: { allowed: true, action: 'disable' },
  //     delete: { allowed: false, action: 'hide' },
  //     view: { allowed: true, action: 'disable' }
  //   },
  //   "dashboard": {
  //     create: { allowed: false, action: 'hide' },
  //     edit: { allowed: false, action: 'hide' },
  //     delete: { allowed: false, action: 'hide' },
  //     view: { allowed: true, action: 'disable' }
  //   },
  //   "settings": {
  //     create: { allowed: false, action: 'hide' },
  //     edit: { allowed: false, action: 'hide' },
  //     delete: { allowed: false, action: 'hide' },
  //     view: { allowed: false, action: 'hide' }
  //   },
  //   "rule": {
  //     create: { allowed: false, action: 'disable' },
  //     edit: { allowed: false, action: 'disable' },
  //     delete: { allowed: true, action: 'disable' },
  //     view: { allowed: true, action: 'disable' }
  //   }
  // }

  // assent={
  //   "explorelogs": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "rule": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "disable"
  //     }
  //   },
  //   "dashboard": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "reports": {
  //     "View": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "user": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "role": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "disable"
  //     }
  //   },
  //   "fleetmanagement": {
  //     "View": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "monitoring": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "deploy": {
  //     "View": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "organization": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "studio": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "disable"
  //     }
  //   },
  //   "alerts_and_ticketing": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   },
  //   "pipeline_stats": {
  //     "View": {
  //       "allowed": false,
  //       "action": "disable"
  //     },
  //     "Add": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Edit": {
  //       "allowed": false,
  //       "action": "hide"
  //     },
  //     "Delete": {
  //       "allowed": false,
  //       "action": "hide"
  //     }
  //   }
  // }

  assent = null

  moduleNames = null



  getPermissions(moduleName: string): any | null {
    return this.assent[moduleName] || null;
  }

  getMenu(): Observable<any> {
    return this.$menu_array
  }

  getUserProfile(reqObj: any) {
    let request = JSON.stringify(reqObj);
    return this.http.post(environment.apiUrl + '/login/userProfile/get',
      request,
      { headers: this.headers });
  }

  postResetPwd(resetPwd: any) {
    return this.http.post(environment.apiUrl + '/login/resetPwd/post',
      resetPwd, { headers: this.headers })
  }

  checkOldPassword(password: any) {
    return this.http.post(environment.apiUrl + '/userlogin/check/userpwd',
      JSON.stringify({ user_name: this.userName, password: password }),
      { headers: this.headers });
  }

  postNewpwd(userObj) {
    const request = JSON.stringify(userObj);
    return this.http.post(environment.apiUrl + '/user/newPwd/post',
      request,
      { headers: this.headers });
  }

  postUserProfile(myProfileForm: any) {
    return this.http.post(environment.apiUrl + '/login/userProfile/post',
      myProfileForm,
      { headers: this.headers });
  }

  languageGrammerGet(platform: [string]) {
    return this.http.post(environment.apiUrl + '/language/grammar/get', JSON.stringify({ "platform": platform }), { headers: this.headers })
  }
  rulelanguageGrammerGet(platform: [string], alertId: number) {
    return this.http.post(environment.apiUrl + '/alerts/grammar/get', JSON.stringify({ "platform": ["all"], "alert_id": alertId }), { headers: this.headers })
  }

  platform_plugins = { }
  alert_rule_plugins = {}
  suggestion_rules = {}
  host_plugins={}
  tokens_map_obj = {}
  // platform_plugins = {
  //   'firewall_fortigate':{
  //     'grammar':`
  // @top Scripts { 
  //     statement { 
  //     SearchCommand |
  //     SearchCommand StatsCommand  |
  //     SearchCommand StatsCommand WhereCommand |
  //     SearchCommand StatsCommand WhereCommand TableCommand |
  //     SearchCommand StatsCommand WhereCommand TableCommand SortCommand |
  //     SearchCommand StatsCommand WhereCommand SortCommand |
  //     SearchCommand StatsCommand TableCommand |
  //     SearchCommand StatsCommand TableCommand SortCommand |
  //     SearchCommand StatsCommand SortCommand

  //   }
  // }

  // @skip { space }

  // SearchCommand { Search?  ( expression | clause | term )  }
  // expression { (( term | clause ) LogicalOperator ( term | clause )) ( LogicalOperator ( term | clause ) )*  }
  // clause {
  //   ( LogicalNegate? ParenL expression ParenR ) |
  //   ( LogicalNegate? ParenL clause ParenR )
  // }
  // term { 
  //   basic |
  //   ( LogicalNegate? ParenL basic ParenR )
  // }

  // basic { stringBasic | stringWildBasic | stringFunctionWhereClause |  numericBasic | numericWildBasic | ipBasic | listBasic | hashTagBasic }


  // stringWildBasic { StringFields  ( InOperator | ContainsOperator | StartswithOperator | EndswithOperator )  WildcardStringValue }
  // stringBasic { StringFields GenericOperator StringValue}
  // stringFunctionWhereClause { 
  // ((StringFunctionType1 | StringFunctionType4 | StringFunctionType5 | StringFunctionType6 | TimestampFunctionType1 | CommonFunctionType2) ((GenericOperator StringValue) | ((InOperator | ContainsOperator | StartswithOperator | EndswithOperator) WildcardStringValue))) 
  // | ((StringFunctionType2 | NumberFunctionType1 | NumberFunctionType2 | NumberFunctionType3 | CommonFunctionType1) (((GenericOperator | NumericOperator) NumericValue) | (InOperator  WildcardNumericValue)))
  // | (StringFunctionType3)
  // | (ListFunctionType1 | ListFunctionType2 | ListFunctionType3)
  // }

  // hashTagBasic { HashTags }

  // StringFunctionType1 { StringFunctionType1Name ParenL StringFields ParenR }
  // StringFunctionType2 { StringFunctionType2Name ParenL StringFields ParenR }
  // StringFunctionType3 { StringFunctionType3Name ParenL StringFields Comma StringValue ParenR }
  // StringFunctionType4 { StringFunctionType4Name ParenL StringFields (Comma StringValue)? ParenR }
  // StringFunctionType5 { StringFunctionType5Name ParenL StringFields Comma StringValue Comma StringValue ParenR }
  // StringFunctionType6 { StringFunctionType6Name ParenL StringFields Comma NumericValue Comma NumericValue ParenR }
  // NumberFunctionType1 { NumberFunctionType1Name ParenL (NumericFields | NumericValue) ParenR }
  // NumberFunctionType2 { NumberFunctionType2Name ParenL (NumericFields | NumericValue) (Comma NumericValue)?  ParenR }
  // NumberFunctionType3 { NumberFunctionType3Name ParenL (NumericFields | NumericValue) Comma (NumericFields | NumericValue) ParenR }
  // TimestampFunctionType1 { TimestampFunctionType1Name ParenL TimestampFields Comma StringValue ParenR }
  // CommonFunctionType1 { CommonFunctionType1Name ParenL NumericFields Comma NumericValue ParenR }
  // CommonFunctionType2 { CommonFunctionType1Name ParenL StringFields Comma StringValue ParenR }
  // ListFunctionType1 { ListFunctionType1Name ParenL StringFields Comma WildCardStringListValueSquareBrac ParenR }
  // ListFunctionType2 { ListFunctionType1Name ParenL NumericFields Comma WildCardStringListValueSquareBrac ParenR }
  // ListFunctionType3 { ListFunctionType1Name ParenL IpFields  Comma WildCardIPListValueSquareBrac ParenR }





  // functionBasic {statsFunc GenericOperator StringValue }
  // numericWildBasic { NumericFields ( InOperator | ContainsOperator | StartswithOperator | EndswithOperator ) ( WildcardNumericValue ) }
  // numericBasic { NumericFields ( GenericOperator | NumericOperator) NumericValue }
  // ipBasic { (IpFields ( GenericOperator | NumericOperator ) IpAddress) | (IpFields InOperator wildCardInIpValue ) | (IpFields ((ContainsOperator wildCardContainsIpValue) | (StartswithOperator wildCardStartswithIpValue) | (EndswithOperator wildCardEndswithIpValue) ) ) }
  // listBasic { (StringFields ((GenericOperator StringListValue) | (InOperator WildCardStringListValue)) | IpFields ((GenericOperator IPListValue) | (InOperator WildCardIPListValue)) | NumericFields ((GenericOperator NumericListValue) | (InOperator WildCardNumericListValue))) }

  // WildcardStringValue { ParenL (StringValue | StringValue ( ( seperator ) StringValue)*) ParenR }
  // WildcardNumericValue { ParenL (NumericValue | NumericValue ( ( seperator ) NumericValue)*) ParenR }
  // WildcardNumericValueSquareBrac { SquareBracL (NumericValue | NumericValue ( ( seperator ) NumericValue)*) SquareBracR }
  // WildCardStringListValue { ParenL (StringListValue | StringListValue ( ( seperator ) StringListValue)*) ParenR }
  // WildCardStringListValueSquareBrac { SquareBracL (StringListValue | StringListValue ( ( seperator ) StringListValue)*) SquareBracR }
  // WildCardNumericListValue { ParenL (NumericListValue | NumericListValue ( ( seperator ) NumericListValue)*) ParenR }

  // WildCardIPListValue { ParenL (IPListValue | IPListValue ( ( seperator ) IPListValue)*) ParenR }
  // WildCardIPListValueSquareBrac { SquareBracL (IPListValue | IPListValue ( ( seperator ) IPListValue)*) SquareBracR }




  // wildCardInIpValue[@name="WildCardIpValue"] {
  //   ParenL ( IpAddress ( seperator IpAddress)*) ParenR
  // }

  // wildCardStartswithIpValue[@name="WildCardIpValue"] {
  //   ParenL ( startsWithIPRule ( seperator startsWithIPRule)*) ParenR
  // }

  // wildCardEndswithIpValue[@name="WildCardIpValue"] {
  //   ParenL ( endsWithIPRule ( seperator endsWithIPRule)*) ParenR
  // }

  // wildCardContainsIpValue[@name="WildCardIpValue"] {
  //   ParenL ( containsIPRule ( seperator containsIPRule)*) ParenR
  // }



  // startsWithIPRule {
  //   StartsWithIP | IpAddress 
  // }
  // endsWithIPRule {
  //   EndsWithIP | IpAddress 
  // }

  // containsIPRule {
  //   ContainsIP | StartsWithIP | EndsWithIP | IpAddress 
  // }






  // StatsCommand { Pipe  Stats ( ( statsFunc statsAlias? ) | ( statsFunc statsAlias? ) ( Comma ( statsFunc statsAlias? ) )* ) statsGroupBy }
  // statsFunc {
  //   GenericStatsFunc ParenL ( StringFields | NumericFields | IpFields )? ParenR |
  //   NumericStatsFunc ParenL NumericFields ParenR
  // }
  // statsAlias {
  //   As Alias
  // }
  // statsGroupBy {
  //   By (( StringFields | NumericFields | IpFields) | (( StringFields | NumericFields | IpFields) ( Comma ( StringFields | NumericFields | IpFields ) )*))
  // }

  // TableCommand { Pipe Table ((Alias | StringFields | NumericFields | IpFields ) | ((Alias | StringFields | NumericFields | IpFields ) ( Comma (Alias | StringFields | NumericFields | IpFields) )*)) }

  // WhereCommand { Pipe Where Alias ( GenericOperator | NumericOperator ) NumericValue }

  // SortCommand { Pipe Sort ( ( (Alias | StringFields | NumericFields | IpFields ) SortOperator ) |  (( Alias | StringFields | NumericFields | IpFields ) SortOperator) ( Comma (Alias | StringFields | NumericFields | IpFields) SortOperator )* ) }



  // @tokens {
  //   space { @whitespace+ }
  //   NumericValue { "-"? $[0-9]+ ("." $[0-9]+)? }
  //   escapedDoubleQuote { """" }
  //   content { (escapedDoubleQuote | !["])* } 
  //   StringValue { '"' content '"' }
  //   StringFields { ("sessionid"|"nextstat"|"outintf"|"setuprate"|"stage"|"status"|"action"|"service"|"policytype"|"poluuid"|"proto"|"reason"|"applist"|"apprisk"|"assignip"|"bandwidth"|"cookies"|"cpu"|"craction"|"crscore"|"devid"|"devname"|"dir"|"disk"|"disklograte"|"level"|"locip"|"locport"|"logdesc"|"mem"|"mode"|"msg"|"app"|"appcat"|"appid"|"remip"|"remport"|"result"|"logid"|"role"|"servicenumber"|"dst_host"|"duration"|"exch"|"fazlograte"|"group"|"hash_id"|"init"|"totalsession"|"trandisp"|"tranip"|"tranport"|"transport"|"tunnelid"|"tunneltype"|"user"|"vd"|"version"|"vpntunnel"|"xauthgroup"|"xauthuser"|"type"|"crlevel"|"dstcountry"|"dstintf"|"dstport"|"policyid"|"source"|"srccountry"|"srcintf"|"subtype"|"transip"|"srcport") }
  //   NumericFields {"sentbyte" | "rcvdbyte"}
  //   LogicalOperator {("AND" | "OR" | "and" | "or")}
  //   LogicalNegate {("NOT" | "not")}
  //   NumericOperator {("<" | ">" | "<=" | ">=")}
  //   GenericOperator {("=" | "!=")}
  //   InOperator {("IN" | "in")}
  //   ContainsOperator {("CONTAINS" | "contains")}
  //   StartswithOperator {("STARTSWITH" | "startswith")}
  //   EndswithOperator {("ENDSWITH" | "endswith")}
  //   GenericStatsFunc {("count")}
  //   NumericStatsFunc {("average" | "sum" | "max" | "min")}
  //   By {("by")}
  //   As {("as")}
  //   Search {("search")}
  //   Stats {("stats")}
  //   Where {("where")}
  //   Table {("table")}
  //   Sort {("sort")}
  //   IpFields { ("tunnelip"|"dstip"|"srcip") }
  //   TimestampFields { ("~~No_List") }
  //   ipdigit { 
  //   ($[1-9]) | 
  //   ($[1-9]$[0-9]) | 
  //   (
  //   ($[1]$[0-9]$[0-9]) | ($[2]$[0-5]$[0-5])
  //   ) 
  //   }
  //   ip { ipdigit "." (ipdigit | $[0]) "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
  //   IpAddress { "'" ip ("/" ($[0-9] | $[1-2]$[0-9] | $[3]$[0-2]))? "'"}
  //   partialip6 { "." (ipdigit | $[0]) }
  //   partialip8 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
  //   partialip10 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) "." (ipdigit | $[0]) }
  //   partialip11 { "." (ipdigit | $[0]) "." }
  //   partialip12 { "." (ipdigit | $[0]) "." (ipdigit | $[0]) "."}

  //   StartsWithIP { "'" ipdigit (partialip6 | partialip8 | partialip11 | partialip12 | ".")? "'"}
  //   EndsWithIP { "'" (partialip6 | partialip8 | partialip10)  ("/" ($[0-9] | $[1-2]$[0-9] | $[3]$[0-2]))?"'" }
  //   ContainsIP { "'" (partialip11 | partialip12) "'" }
  //   SortOperator {("ASC" | "DSC")}
  //   Alias { '"' content '"' }
  //   ParenL[@name="openparam"] {'('}
  //   ParenR[@name="closeparam"] {')'} 
  //   SquareBracL { '[' }
  //   SquareBracR { ']' }
  //   Pipe { '|' }  
  //   Comma { ',' }
  //   seperator { Comma space* }
  //   StringListValue { ("$hostile_country") }
  //   NumericListValue {"$hihgvol"}
  //   IPListValue { ("$private_ip" | "$cust_public_ip") }
  //   HashTags {("#inboundtraffic" | "#outboundtraffic")}
  //   StringFunctionType1Name { ("lower" | "upper" | "md5" | "url_decode" | "url_encode") }
  //   StringFunctionType2Name { ("len") }
  //   StringFunctionType3Name { ("match") }
  //   StringFunctionType4Name { ("trim" | "ltrim" | "rtrim") }
  //   StringFunctionType5Name { ("replace") }
  //   StringFunctionType6Name { ("substr") }
  //   NumberFunctionType1Name { ("abs" | "ceil" | "floor" | "trunc") }
  //   NumberFunctionType2Name { ("round") }
  //   NumberFunctionType3Name { ("add" | "subtract" | "multiply" | "divide") }
  //   TimestampFunctionType1Name { ("strftime") }
  //   CommonFunctionType1Name { ("ifempty") }
  //   ListFunctionType1Name { ("exists_in_the_list") }

  // }

  // @detectDelim


  // `,
  //     'external_tokens':{
  //       "logical_operator": ["AND", "OR", "and", "or"],
  //       "logical_negate": ["NOT", "not"],
  //       "numeric_operator": ["<", ">", "<=", ">="],
  //       "generic_operator": ["=", "!="],
  //       "in_operator": ["IN", "in"],
  //       "contains_operator": ["CONTAINS", "contains"],
  //       "startswith_operator": ["STARTSWITH", "startswith"],
  //       "endswith_operator": ["ENDSWITH", "endswith"],
  //       "generic_stats_fn": ["count", "lower"],
  //       "numeric_stats_fn": ["average", "sum", "max", "min"],
  //       "by": ["by"],
  //       "alias": ["as"],
  //       "search": ["search"],
  //       "stats": ["stats"],
  //       "where": ["where"],
  //       "table": ["table"],
  //       "sort": ["sort"],
  //       "sort_operator": ["ASC", "DSC"],
  //       "StringListValue":["$hostile_country"],
  //       "NumericListValue": [],
  //       "IPListValue": ["$private_ip","$cust_public_ip"],
  //       "StringFunctionType1Name": ["lower","upper","md5","url_decode","url_encode"],
  //       "StringFunctionType2Name": ["len"],
  //       "StringFunctionType3Name": ["match"],
  //       "StringFunctionType4Name": ["trim","ltrim","rtrim"],
  //       "StringFunctionType5Name": ["replace"],
  //       "StringFunctionType6Name": ["substr"],
  //       "NumberFunctionType1Name": ["abs","ceil","floor","trunc"],
  //       "NumberFunctionType2Name": ["round"],
  //       "NumberFunctionType3Name": ["add","subtract","multiply","divide"],
  //       "TimestampFunctionType1Name": ["strftime"],

  //     }
  //   }

  // }
  platformobj = {
    "windows": {
      "string_fields": [],
      "grammar": ""
    }
  }

  updatePlatformPlugins(platformobj) {
    this.platform_plugins = { ...this.platform_plugins, ...platformobj }
  }

  updateAlertRulePlugins(platformobj) {
    this.alert_rule_plugins = { ...this.alert_rule_plugins, ...platformobj }
  }

  buildPartitionMap(){
    this.partitions.rows.forEach(part=>{
      this.partitionsMapObj[part.partition_name_disp]=part.partition_name
    })
    
//console.log(this.partitionsMapObj)
  }

  getLanguageGrammar_old(platform) {
    return new Promise((resolve, reject) => {

      if (this.platform_plugins.hasOwnProperty(platform)) {
        resolve(this.platform_plugins[platform])
      } else {
        this.languageGrammerGet(platform)
          .subscribe(
            (platformobj: any) => {
              this.updatePlatformPlugins(platformobj)
              //console.log(platformobj)
              resolve(this.platform_plugins[platform])
            },
            (error) => {
              //console.log(error)
              reject(error)
            })
      }
    })

  }

  getLanguageGrammar(platform: any,partitions?) {
    
    let platform_plugins = {}
    return new Promise((resolve, reject) => {
      const allExist = platform.every((key) => key in this.platform_plugins);
      if (allExist) {
        const filtered = platform.reduce((acc, key) => {
          if (Object.prototype.hasOwnProperty.call(this.platform_plugins, key)) {
            acc[key] = this.platform_plugins[key];
          }
          // console.log("Platform plugins --> ",this.platform_plugins)
          let byPlatform={}

          let customPlugins={}

          if(partitions){
//console.log("Partitions=->",partitions)

            partitions.forEach(val=>{
//console.log("Platform Id ->",val.platform_id)
              byPlatform[val.platform_id]=[]
            })

            partitions.forEach(val=>{
              // console.log("Platform Id ->",val.platform_id)
              byPlatform[val.platform_id].push(this.platform_plugins[val.partition_name])
            })

            customPlugins=this.buildPlugins(byPlatform)
          }
          return {...acc,...customPlugins};
        }, {});
        resolve(filtered)
      } else {
        this.languageGrammerGet(platform)
          .subscribe(
            (platformobj: any) => {
// console.log(platformobj)
//console.log("Platform plugins --> ",this.platform_plugins)
              // console.log("*****languageGrammerGet platform***********",platform)
              platform.forEach(element => {
                let newgrammar = this.grammarTemplate
                Object.keys(platformobj[element]['substitutions']).forEach((key) => {

                  newgrammar = newgrammar.replace('"' + key + '"', platformobj[element]['substitutions'][key])
                })
// console.log(newgrammar)
                platformobj[element] = { ...{ "grammar": this.grammarTemplate }, ...platformobj[element] }
// console.log(platformobj)
                let compiled = buildParser(newgrammar);

                // console.log(compiled)

                let customLang = LRLanguage.define({ parser: compiled, name: element }).configure({
                  props: [
                    styleTags({
                      StringFields: tags.keyword,
                      NumericFields: tags.keyword,
                      IpFields: tags.keyword,
                      GenericOperator: tags.operator,
                      NumericOperator: tags.operator,
                      LogicalOperator: tags.logicOperator,
                      LogicalNegate: tags.logicOperator,
                      InOperator: tags.variableName,
                      ContainsOperator: tags.variableName,
                      StartswithOperator: tags.variableName,
                      EndswithOperator: tags.variableName,
                      StringValue: tags.string,
                      Date: tags.string,
                      Alias: tags.string,
                      Platform: tags.number,
                      NumericValue: tags.number,
                      IpAddress: tags.integer,
                      ContainsIP: tags.integer,
                      StartsWithIP: tags.integer,
                      EndsWithIP: tags.integer,
                      CommonIP: tags.integer,
                      openparam: tags.bracket,
                      closeparam: tags.bracket,
                      From: tags.bool,
                      When: tags.bool,
                      Let: tags.bool,
                      Join: tags.bool,
                      On: tags.bool,
                      Search: tags.bool,
                      Calculate: tags.bool,
                      By: tags.bool,
                      Fetch: tags.bool,
                      Where: tags.bool,
                      Sort: tags.bool,
                      Limit: tags.bool,
                      Distinct: tags.operator,
                      FetchAll: tags.operator,
                      SortOperator: tags.operator,
                      StringListValue: tags.list,
                      NumericListValue: tags.list,
                      IPListValue: tags.list,
                      HashTags: tags.heading3,
                      StringFunctionType1Name: tags.atom,
                      StringFunctionType2Name: tags.atom,
                      StringFunctionType3Name: tags.atom,
                      StringFunctionType4Name: tags.atom,
                      StringFunctionType5Name: tags.atom,
                      StringFunctionType6Name: tags.atom,
                      NumberFunctionType1Name: tags.atom,
                      NumberFunctionType2Name: tags.atom,
                      NumberFunctionType3Name: tags.atom,
                      TimestampFunctionType1Name: tags.atom,
                      TimestampFunctionType2Name: tags.atom,
                      ListFunctionType1Name: tags.atom,
                      TimestampFields: tags.keyword,
                      TimeFormat: tags.string,

                    }),
                    indentNodeProp.add({
                      Application: context => context.column(context.node.from) + context.unit
                    }),
                    foldNodeProp.add({
                      Application: foldInside
                    })
                  ]
                })
                // console.log(customLang)
                platformobj[element] = { ...{ "customLang": customLang }, ...platformobj[element] }
              });

              this.updatePlatformPlugins(platformobj)

              let byPlatform={}

              let customPlugins={}

              if(partitions){
//console.log("Partitions=->",partitions)

                partitions.forEach(val=>{
//console.log("Platform Id ->",val.platform_id)
                  byPlatform[val.platform_id]=[]
                })

                partitions.forEach(val=>{
                  // console.log("Platform Id ->",val.platform_id)
                  byPlatform[val.platform_id].push(this.platform_plugins[val.partition_name])
                })

                customPlugins=this.buildPlugins(byPlatform)
              }

              // console.log(platformobj)
              const filtered = platform.reduce((acc, key) => {
                if (Object.prototype.hasOwnProperty.call(this.platform_plugins, key)) {
                  acc[key] = this.platform_plugins[key];
                }
                return acc;
              }, {});
              // resolve(filtered)
              resolve({...filtered,...customPlugins})
            },
            (error) => {
              //console.log(error)
              reject(error)
            })
      }
    })
    

  }

  getEventRuleLanguageGrammar(platform: any,partitions?) {
//console.group("Check")
//console.log({platform})
//console.log({partitions})
//console.groupEnd()
    let temp=[]

    let  copy:any
    
    let platform_plugins = {}
    return new Promise((resolve, reject) => {
      const allExist = platform.every((key) => key in this.platform_plugins);
      if (allExist) {
        const filtered = platform.reduce((acc, key) => {
          if (Object.prototype.hasOwnProperty.call(this.platform_plugins, key)) {
            acc[key] = this.platform_plugins[key];
          }
          // console.log("Platform plugins --> ",this.platform_plugins)
          let byPlatform={}

          let customPlugins={}

          if(partitions){
//console.log("Partitions=->",partitions)

            partitions.forEach(val=>{
//console.log("Platform Id ->",val.platform_id)
              byPlatform[val.platform_id]=[]
            })

            partitions.forEach(val=>{
              // console.log("Platform Id ->",val.platform_id)
              byPlatform[val.platform_id].push(this.platform_plugins[val.partition_name])
            })

            customPlugins=this.buildPlugins(byPlatform)
          }
          return {...acc,...customPlugins};
          // return acc;
        }, {});
        resolve(filtered)
      } else {
        this.languageGrammerGet(platform)
          .subscribe(
            (platformobj: any) => {
              // console.log("Platform plugins --> ",this.platform_plugins)
              // console.log("*****languageGrammerGet platform***********",platform)
              platform.forEach(element => {
                let newgrammar = this.grammarTemplate
                Object.keys(platformobj[element]['substitutions']).forEach((key) => {

                  newgrammar = newgrammar.replace('"' + key + '"', platformobj[element]['substitutions'][key])
                })
                // console.log({newgrammar})
                platformobj[element] = { ...{ "grammar": this.grammarTemplate }, ...platformobj[element] }
                let compiled = buildParser(newgrammar);

                let customLang = LRLanguage.define({ parser: compiled, name: element }).configure({
                  props: [
                    styleTags({
                      StringFields: tags.keyword,
                      NumericFields: tags.keyword,
                      IpFields: tags.keyword,
                      GenericOperator: tags.operator,
                      NumericOperator: tags.operator,
                      LogicalOperator: tags.logicOperator,
                      LogicalNegate: tags.logicOperator,
                      InOperator: tags.variableName,
                      ContainsOperator: tags.variableName,
                      StartswithOperator: tags.variableName,
                      EndswithOperator: tags.variableName,
                      StringValue: tags.string,
                      Date: tags.string,
                      Alias: tags.string,
                      Platform: tags.number,
                      NumericValue: tags.number,
                      IpAddress: tags.integer,
                      ContainsIP: tags.integer,
                      StartsWithIP: tags.integer,
                      EndsWithIP: tags.integer,
                      CommonIP: tags.integer,
                      openparam: tags.bracket,
                      closeparam: tags.bracket,
                      From: tags.bool,
                      When: tags.bool,
                      Let: tags.bool,
                      Join: tags.bool,
                      On: tags.bool,
                      Search: tags.bool,
                      Calculate: tags.bool,
                      By: tags.bool,
                      Fetch: tags.bool,
                      Where: tags.bool,
                      Sort: tags.bool,
                      Limit: tags.bool,
                      Distinct: tags.operator,
                      FetchAll: tags.operator,
                      SortOperator: tags.operator,
                      StringListValue: tags.list,
                      NumericListValue: tags.list,
                      IPListValue: tags.list,
                      HashTags: tags.heading3,
                      StringFunctionType1Name: tags.atom,
                      StringFunctionType2Name: tags.atom,
                      StringFunctionType3Name: tags.atom,
                      StringFunctionType4Name: tags.atom,
                      StringFunctionType5Name: tags.atom,
                      StringFunctionType6Name: tags.atom,
                      NumberFunctionType1Name: tags.atom,
                      NumberFunctionType2Name: tags.atom,
                      NumberFunctionType3Name: tags.atom,
                      TimestampFunctionType1Name: tags.atom,
                      TimestampFunctionType2Name: tags.atom,
                      ListFunctionType1Name: tags.atom,
                      TimestampFields: tags.keyword,
                      TimeFormat: tags.string,

                    }),
                    indentNodeProp.add({
                      Application: context => context.column(context.node.from) + context.unit
                    }),
                    foldNodeProp.add({
                      Application: foldInside
                    })
                  ]
                })
                platformobj[element] = { ...{ "customLang": customLang }, ...platformobj[element] }

               
                // platformobj[element].platform_fields.forEach(val=>{
                //     temp.push(val)
                // })
               
              });
              // let tempSet =new Set(temp) 
              // temp =Array.from(tempSet)
              // console.log(Array.from(tempSet))

              // console.log("PlatformObj ======------>",platformobj)
              // console.log({platform})

              // let temp=[]

              // Object.keys(platformobj).forEach(key=>{
              //   temp.push(key)
              //   console.log(" =---> =--->",platformobj[key].substitutions)
              // })

              // if(temp.length > 1){
              //   console.log(getObjectDiff(platformobj[temp[0]].substitutions,platformobj[temp[1]].substitutions))
              // }


              // copy = JSON.parse(JSON.stringify(platformobj))
              
              this.updatePlatformPlugins(platformobj)
              let byPlatform={}

              let customPlugins={}

              if(partitions){
                // console.log("Partitions=->",partitions)

                partitions.forEach(val=>{
                  // console.log("Platform Id ->",val.platform_id)
                  byPlatform[val.platform_id]=[]
                })

                partitions.forEach(val=>{
                  // console.log("Platform Id ->",val.platform_id)
                  byPlatform[val.platform_id].push(this.platform_plugins[val.partition_name])
                })

                customPlugins=this.buildPlugins(byPlatform)

                // Object.keys(byPlatform).forEach(key=>{

                //   let plugins={}


                //   let sub={}
                //   let ext={}
                //   let custLang
                //   let gram
                //   let platFields=[]
                //   let sugRules={}
                //   let tMapJson={}
                  
                //   if(byPlatform[key].length > 1){
                //     byPlatform[key].forEach(id=>{
                //       // console.log("Inside loop -->",sub)
                //       // sub={...sub,...id.substitutions}
                //       custLang=id.customLang
                //       gram=id.grammar
                //       sugRules=id.suggestion_rules
                //       tMapJson=id.tokens_map_json

                //       platFields=[...platFields,...id.platform_fields]

                //       // console.log("PlatformFields ->",id.platform_fields)
                //       // console.log({platFields})

                //       Object.keys(id.substitutions).forEach(subs=>{
                //         // console.log(id.substitutions[subs])
                //         sub[subs]=sub[subs]? sub[subs]+"|"+id.substitutions[subs]:id.substitutions[subs]

                //       })

                //       Object.keys(id.external_tokens).forEach(subs=>{
                //         // console.log(id.substitutions[subs])
                //         // console.log(id.external_tokens[subs])
                //         ext[subs]=ext[subs]? ext[subs].concat(id.external_tokens[subs]):id.external_tokens[subs]

                //       })
                //       // console.log("Sub ->",id.substitutions)
                      
                //     })
                //     // console.log({ext})
                //     // console.log({sub})

                  


                //     Object.keys(ext).forEach(extKey=>{
                //       let list= ext[extKey]
                //       let newList = list.filter((item, index) => list.indexOf(item) !== index);
                //       ext[extKey]=newList
                //     })

                //     // console.group("SPlIT SUB")
                //     Object.keys(sub).forEach(subKey=>{
                //       let list =sub[subKey].split("|")

                //       let newList = list.filter((item, index) => list.indexOf(item) !== index);

                //       // console.log({newList})

                //       let newStr=""
                //       newList.forEach((listKey,i)=>{
                //         if(i !=0){
                //           newStr+="|"
                //         }
                //         newStr +=listKey
                //       })
                //       sub[subKey]=newStr
                //       // console.log({list})
                //     })
                   

                //     const seen = new Set();
                //     const platList = [];
                    
                //     platFields.forEach(obj => {
                //       if (seen.has(obj.disp)) {
                //         platList.push(obj);
                //       } else {
                //         seen.add(obj.disp);
                //       }
                //     });
                    
                //     // console.log(platList);
                
                //     console.log({sub})
                //     console.log({ext})
                //     console.log({platList})

                //     plugins={"substitutions":sub,"customLang":custLang,"external_tokens":ext,"grammar":gram,"platform_fields":platList,"suggestion_rules":sugRules,"tokens_map_json":tMapJson}
                //     customPlugins[key]=plugins
                //     // console.groupEnd()
                //   }

                  

                  
                // })

                
              }

              // console.log({customPlugins})
              // console.log("By Platform Id --->",byPlatform)


              
              

              // console.log({copy})
              // console.log(this.platform_plugins)
              const filtered = platform.reduce((acc, key) => {
                if (Object.prototype.hasOwnProperty.call(this.platform_plugins, key)) {
                  acc[key] = this.platform_plugins[key];
                }
                return acc;
              }, {});
//console.log({...filtered,...customPlugins})
              resolve({...filtered,...customPlugins})
            },
            (error) => {
              //console.log(error)
              reject(error)
            })
      }
    })
    

  }
 
  // Build Custom PlugIns for grouped partitions
  buildPlugins(byPlatform){
    let customPlugins={}
    // console.log({byPlatform})
    Object.keys(byPlatform).forEach(key=>{

      let plugins={}


      let sub={}
      let ext={}
      let custLang
      let gram
      let platFields=[]
      // let sugRules={}
      // let tMapJson={}
      if(key != '0'){
        if(byPlatform[key].length > 1){
          byPlatform[key].forEach(id=>{
            // console.log("Inside loop -->",sub)
            // sub={...sub,...id.substitutions}
            custLang=id.customLang
            gram=id.grammar
            // sugRules=id.suggestion_rules
            // tMapJson=id.tokens_map_json

            platFields=[...platFields,...id.platform_fields]

            // console.log("PlatformFields ->",id.platform_fields)
            // console.log({platFields})

            Object.keys(id.substitutions).forEach(subs=>{
              // console.log(id.substitutions[subs])
              sub[subs]=sub[subs]? sub[subs]+"|"+id.substitutions[subs]:id.substitutions[subs]

            })

            Object.keys(id.external_tokens).forEach(subs=>{
              // console.log(id.substitutions[subs])
              // console.log(id.external_tokens[subs])
              ext[subs]=ext[subs]? ext[subs].concat(id.external_tokens[subs]):id.external_tokens[subs]

            })
            // console.log("Sub ->",id.substitutions)
            
          })
          // console.log({ext})
          // console.log({sub})

        


          Object.keys(ext).forEach(extKey=>{
            let list= ext[extKey]
            let newList = list.filter((item, index) => list.indexOf(item) !== index);
            ext[extKey]=newList
          })

          // console.group("SPlIT SUB")
          Object.keys(sub).forEach(subKey=>{
            let list =sub[subKey].split("|")

            let newList = list.filter((item, index) => list.indexOf(item) !== index);

            // console.log({newList})

            let newStr=""
            newList.forEach((listKey,i)=>{
              if(i !=0){
                newStr+="|"
              }
              newStr +=listKey
            })
            sub[subKey]=newStr
            // console.log({list})
          })
        

          const seen = new Set();
          const platList = [];
          
          platFields.forEach(obj => {
            if (seen.has(obj.disp)) {
              platList.push(obj);
            } else {
              seen.add(obj.disp);
            }
          });
          
          // console.log(platList);
      
  //console.log({sub})
  //console.log({ext})
  //console.log({platList})

          plugins={"substitutions":sub,"customLang":custLang,"external_tokens":ext,"grammar":gram,"platform_fields":platList}
          customPlugins[key]=plugins
          // console.groupEnd()
        }
      }

      

      
    })

    return customPlugins
  }

  getruleLanguageGrammar(platform, alertId) {
    return new Promise((resolve, reject) => {
      //   if(this.platform_plugins.hasOwnProperty(platform)){
      //     resolve(this.platform_plugins[platform])
      // } else {
        let temp=[]
      this.rulelanguageGrammerGet([platform], alertId)
        .subscribe(
          (platformobj: any) => {
            let newgrammar = this.grammarTemplate
            Object.keys(platformobj[alertId]['substitutions']).forEach((key) => {
              newgrammar = newgrammar.replace('"' + key + '"', platformobj[alertId]['substitutions'][key])

            })
            newgrammar = newgrammar.replace("SubScripts", "Scripts")
            // platformobj[alertId] = { ...{ "grammar": newgrammar }, ...platformobj[alertId] }
            platformobj[alertId] = { ...{ "grammar": this.grammarTemplate }, ...platformobj[alertId] }
                let compiled = buildParser(newgrammar);

                let customLang = LRLanguage.define({ parser: compiled, name: alertId }).configure({
                  props: [
                    styleTags({
                      StringFields: tags.keyword,
                      NumericFields: tags.keyword,
                      IpFields: tags.keyword,
                      GenericOperator: tags.operator,
                      NumericOperator: tags.operator,
                      LogicalOperator: tags.logicOperator,
                      LogicalNegate: tags.logicOperator,
                      InOperator: tags.variableName,
                      ContainsOperator: tags.variableName,
                      StartswithOperator: tags.variableName,
                      EndswithOperator: tags.variableName,
                      StringValue: tags.string,
                      Date: tags.string,
                      Alias: tags.string,
                      Platform: tags.number,
                      NumericValue: tags.number,
                      IpAddress: tags.integer,
                      ContainsIP: tags.integer,
                      StartsWithIP: tags.integer,
                      EndsWithIP: tags.integer,
                      CommonIP: tags.integer,
                      openparam: tags.bracket,
                      closeparam: tags.bracket,
                      From: tags.bool,
                      When: tags.bool,
                      Let: tags.bool,
                      Join: tags.bool,
                      On: tags.bool,
                      Search: tags.bool,
                      Calculate: tags.bool,
                      By: tags.bool,
                      Fetch: tags.bool,
                      Where: tags.bool,
                      Sort: tags.bool,
                      Limit: tags.bool,
                      Distinct: tags.operator,
                      FetchAll: tags.operator,
                      SortOperator: tags.operator,
                      StringListValue: tags.list,
                      NumericListValue: tags.list,
                      IPListValue: tags.list,
                      HashTags: tags.heading3,
                      StringFunctionType1Name: tags.atom,
                      StringFunctionType2Name: tags.atom,
                      StringFunctionType3Name: tags.atom,
                      StringFunctionType4Name: tags.atom,
                      StringFunctionType5Name: tags.atom,
                      StringFunctionType6Name: tags.atom,
                      NumberFunctionType1Name: tags.atom,
                      NumberFunctionType2Name: tags.atom,
                      NumberFunctionType3Name: tags.atom,
                      TimestampFunctionType1Name: tags.atom,
                      TimestampFunctionType2Name: tags.atom,
                      ListFunctionType1Name: tags.atom,
                      TimestampFields: tags.keyword,
                      TimeFormat: tags.string,

                    }),
                    indentNodeProp.add({
                      Application: context => context.column(context.node.from) + context.unit
                    }),
                    foldNodeProp.add({
                      Application: foldInside
                    })
                  ]
                })
                platformobj[alertId] = { ...{ "customLang": customLang }, ...platformobj[alertId] }

               

                // platformobj[alertId].platform_fields.forEach(val=>{
                //     temp.push(val)
                // })
               
              
              let tempSet =new Set(temp) 
              temp =Array.from(tempSet)
          
              // console.log(Array.from(tempSet))

              // console.log(newgrammar)
              
            this.updateAlertRulePlugins(platformobj)
//console.log(this.alert_rule_plugins)
            resolve({[alertId]:this.alert_rule_plugins[alertId]})
          },
          (error) => {
//console.log(error)
            reject(error)
          })
    }
      // }
    )
  

  }


  // getCommonFields(platform: any) {
  //   return this.http.post(environment.apiUrl + '/common/platformFields/get', JSON.stringify(platform),
  //    { headers: this.headers })
  //     .pipe(takeUntil(this.$destroy))
  // }
  runtest(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/rule/testRun/get', JSON.stringify(reqobj), { headers: this.headers });
  }

  toUtcTimeZonefromUser(timestring: any,format="YYYY-MM-DD HH:mm:ss") {
    const timezone = this.timeZone;
    if (typeof timestring === 'string') {
      return moment.tz(timestring,format, timezone).utc()
    } else if (typeof timestring === 'number') {
      return moment.unix(timestring).utc();
    }
  }

  getcurrentuserTime() {
    const timezone = this.timeZone;
    // console.log("->",this.sharedService.timeZone)
    // console.log("->",moment().tz(timezone))
    return moment.tz(timezone);
  }

  getTimerangeFromMetaDate(metaDate: any) {
    let date=[this.toUtcTimeZonefromUser(this.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.toUtcTimeZonefromUser(this.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
    return date
  }

  calculate_timerange(time: any) {
    const currentusertime = this.getcurrentuserTime();
    // const currentusertime = this.timezoneservice.getUtcTime();

    if (time[1] == "hour") {
      const start_date = currentusertime.clone().subtract(time[2], 'hour');
      return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "today") {
      const start_date = currentusertime.clone();
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "yesterday") {
      const start_date = currentusertime.clone().subtract(1, 'days');
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    } else {
      const previousdate = currentusertime.clone().subtract(time[2], 'days');
      return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    }
  }

  getSubtitle(time: any) {
    const currentusertime = this.getcurrentuserTime();
    // const currentusertime = this.timezoneservice.getUtcTime();

    if (time[1] == "hour") {
      const start_date = currentusertime.clone().subtract(time[2], 'hour');
      return [start_date.format('DD MMM'), currentusertime.format('DD MMM')];
    } else if (time[1] == "today") {
      const start_date = currentusertime.clone();
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('DD MMM'), currentusertime.format('DD MMM')];
    } else if (time[1] == "yesterday") {
      const start_date = currentusertime.clone().subtract(1, 'days');
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('DD MMM'), start_date.endOf('day').format('DD MMM')];
    } else {
      const previousdate = currentusertime.clone().subtract(time[2], 'days');
      return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('DD MMM'), currentusertime.format('DD MMM')];
    }
  }

}


